<template>
  <v-card flat class="rounded-lg">
    <v-row class="ma-0">
      <v-col cols="auto">
        <v-skeleton-loader
          width="65"
          height="65"
          type="image"
          class="rounded-lg"
        />
      </v-col>

      <v-col class="text-start align-self-center ps-0">
        <v-skeleton-loader
          max-width="180"
          height="12"
          type="text"
          class="mb-2"
        />

        <v-skeleton-loader
          max-width="170"
          height="12"
          type="text"
          class="mb-2"
        />

        <v-skeleton-loader max-width="160" height="12" type="text" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {};
</script>
